import React from "react";
import CardBasic from "../CardBasic";

export default function CardOutlet({
  i,
  data,
  enActionEdit,
  editFunction,
  deleteFunction,
  isDisable,
}) {
  return (
    <CardBasic
      key={data.outlet_kartini_id}
      i={data.outlet_kartini_id}
      title={data.outlet_kartini_name}
      isDisable={isDisable}
      enActionDelete={true}
      enActionEdit={enActionEdit}
      editFunction={editFunction}
      deleteFunction={deleteFunction}
      data={data}
    >
      <div className="px-5 py-3">
        <div className="space-y-3">
          <p className="text-gray-500 text-xs">{data.address}</p>
        </div>
      </div>
    </CardBasic>
  );
}
